/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { Button } from 'antd'
import React, { useContext, useEffect, useState } from 'react'
import 'react-circular-progressbar/dist/styles.css'
import { useTranslation } from 'react-i18next'
import { useMutation, useQuery } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Wizard, useWizard } from 'react-use-wizard'
import * as s from './ProfileForm.styles'

import { useDidMount } from '../../../../hooks/useDidMount'
import { setTalent } from '../../../../redux/reducers/talentSlice'
import { sendAmplitudeData } from '../../../../services/amplitude'
import { FeathersContext } from '../../../../services/feathers'
import GeneralStep from '../../Home/GeneralStep/GeneralStep'
import HeaderOnboarding from '../../Home/HeaderOnboarding/HeaderOnboarding'
import JobDomainStep from '../../Home/JobDomainStep/JobDomainStep'
import SectorStep from '../../Home/SectorStep/SectorStep'

const Profile = () => {
  const feathers = useContext(FeathersContext)
  const dispatch = useDispatch()
  const didMount = useDidMount()
  const { t } = useTranslation(['common', 'talentArea'], {
    useSuspense: false,
  })

  const {
    id: talentId,
    firstname,
    resume,
    remoteWorking,
  } = useSelector((state) => state.talent)
  const talent = useSelector((state) => state.talent)
  const [actualResume, setActualResume] = useState({})

  const { data } = useQuery({
    queryKey: 'talent',
    queryFn: async () => {
      if (!talentId) {
        const response = await feathers.service('talents').get(talentId)

        return response
      }
    },
    onSuccess: (data) => {
      if (data) {
        dispatch(setTalent(data))
      }
    },
    refetchOnWindowFocus: false,
    refetchInterval: 1000 * 60 * 3, // 3 minutes
  })

  const updateTalent = useMutation(
    async ({
      contractTypes,
      experience,
      researchStatus,
      salaryRange,
      location,
      jobDomain,
      subJob,
      sector,
      subSector,
      githubUrl,
      linkedinUrl,
      schoolLevel,
    }) => {
      sendAmplitudeData('Talent - Update Profile Setting', {})

      return feathers.service('talents').patch(talentId, {
        contractTypes,
        experience,
        researchStatus,
        researchStatusUpdatedAt: new Date(),
        salaryRange,
        location,
        jobDomain,
        subJob,
        sector,
        subSector,
        githubUrl,
        linkedinUrl,
        schoolLevel,
        remoteWorking,
      })
    },

    {
      onError: (error) => {
        console.error(error)
      },
    },
  )

  useEffect(() => {
    if (Object.keys(resume).length) {
      setActualResume(resume)
    }
  }, [resume])

  useEffect(() => {
    // skip initial render
    if (!didMount) return null

    if (talent?.resume?.id !== actualResume?.id) {
      return
    }

    updateTalent.mutate(talent)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [talent])

  return (
    <s.WrapperProfile>
      <div className="main-home">
        <main className="wizard-container">
          <Wizard header={<HeaderOnboarding />} footer={<FooterWizard />}>
            <GeneralStep />
            <JobDomainStep />
            <SectorStep />
          </Wizard>
        </main>
      </div>
    </s.WrapperProfile>
  )
}

Profile.propTypes = {}

Profile.defaultProps = {}

export default Profile

const FooterWizard = () => {
  const { previousStep, nextStep, isFirstStep, isLastStep } = useWizard()

  const history = useHistory()
  const routeChange = () => {
    const path = `jobs`
    history.push(path)
  }

  return (
    <div className="flex buttonRow">
      {!isFirstStep && (
        <Button className="basic-btn buttonPrevious" onClick={previousStep}>
          Previous
        </Button>
      )}
      {!isLastStep && (
        <Button className="basic-btn buttonNext" onClick={nextStep}>
          Next
        </Button>
      )}
      {isLastStep && (
        <Button className="basic-btn buttonNext" onClick={routeChange}>
          Finish
        </Button>
      )}
    </div>
  )
}
